import { atom, createStore } from 'jotai'

// Single shared store so that non-React code (e.g. the axios 401 interceptor)
// can read/clear auth state through the same instance the React tree uses.
export const jotaiStore = createStore()

// Initialize from localStorage
const getInitialAccessToken = () => {
  try {
    return localStorage.getItem('accessToken_r4r')
  } catch {
    return null
  }
}

const getInitialRefreshToken = () => {
  try {
    return localStorage.getItem('refreshToken_r4r')
  } catch {
    return null
  }
}

// Create base atoms with initial values from localStorage
const baseAccessTokenAtom = atom<null | string>(getInitialAccessToken())
const baseRefreshTokenAtom = atom<null | string>(getInitialRefreshToken())

// Create derived atoms that sync to localStorage on write
export const accessTokenAtom = atom(
  (get) => get(baseAccessTokenAtom),
  (get, set, newValue: null | string) => {
    set(baseAccessTokenAtom, newValue)
    try {
      if (newValue === null) {
        localStorage.removeItem('accessToken_r4r')
      } else {
        localStorage.setItem('accessToken_r4r', newValue)
      }
    } catch (error) {
      console.error('Failed to update localStorage:', error)
    }
  }
)

export const refreshTokenAtom = atom(
  (get) => get(baseRefreshTokenAtom),
  (get, set, newValue: null | string) => {
    set(baseRefreshTokenAtom, newValue)
    try {
      if (newValue === null) {
        localStorage.removeItem('refreshToken_r4r')
      } else {
        localStorage.setItem('refreshToken_r4r', newValue)
      }
    } catch (error) {
      console.error('Failed to update localStorage:', error)
    }
  }
)

export const hasActiveSession = () => !!jotaiStore.get(accessTokenAtom)

// Clears the auth state. Because every data hook is gated on `!!accessToken`,
// clearing the atoms disables all queries (stopping any polling loops) and the
// route guards redirect to the sign-in page.
export const clearAuthTokens = () => {
  jotaiStore.set(accessTokenAtom, null)
  jotaiStore.set(refreshTokenAtom, null)
}
